import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Order, Region } from '@compumark/order-management-client';

import { RegionsDialogComponent } from './register-dialog/regions-dialog.component';

@Component({
  selector: 'app-register-renderer',
  templateUrl: './region-renderer.component.html',
  styleUrls: ['./region-renderer.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegionRendererComponent
  implements ICellRendererAngularComp, AfterViewInit, OnDestroy
{
  private dialog = inject(MatDialog);

  @ViewChild('registerContainer', { static: true })
  private registerContainer!: ElementRef<HTMLElement>;

  public regions!: Region[];
  public readonly isOverflowing = signal(false);
  private order!: Order;
  private resizeObserver?: ResizeObserver;

  agInit(params: ICellRendererParams): void {
    this.regions = params.value;
    this.order = params.data;
  }

  ngAfterViewInit(): void {
    const element = this.registerContainer.nativeElement;
    this.resizeObserver = new ResizeObserver(() =>
      this.isOverflowing.set(this.checkOverflow(element)),
    );
    this.resizeObserver.observe(element);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  refresh(): boolean {
    return false;
  }

  checkOverflow(element: any): boolean {
    return (
      element.offsetHeight < element.scrollHeight ||
      element.offsetWidth < element.scrollWidth
    );
  }

  regionsToString(): string {
    return this.regions
      .filter((region) => region !== null && region !== undefined)
      .sort((a, b) => {
        const labelA = a.label ?? '';
        const labelB = b.label ?? '';
        return labelA.localeCompare(labelB);
      })
      .map((r) => r.label + (r.limited ? ' (Limited)' : ''))
      .filter((label) => label.trim() !== '')
      .join(', ');
  }

  openViewAllRegionsDialog(): void {
    this.dialog.open(RegionsDialogComponent, {
      data: {
        trademarkName: this.order.trademarkName,
        regions: this.regions,
      },
      width: '25vw',
      height: '100%',
      position: { right: '0' },
      panelClass: 'regions-dialog',
    });
  }
}
